import * as API from "./base";

export const create = (postal_code, userId) =>
  userId ?
    true : // this creates a home record
    API.post("/api/authenticated/verify_address", { postal_code }); // This creates an ephemeral home
